module.exports = __webpack_public_path__ + "static/img/1.14f44496.png";